/* eslint-disable @next/next/no-img-element */
import {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Modal } from "@/utils/bootstrap";
import CancelIcon from "./CancelIcon"; // Assuming CancelIcon is your custom component

interface MediaPreviewModalRef {
  showMedia(src: string, type: "video" | "image"): void;
}

const extractMediaExtension = (src: string): string => {
  const url = new URL(src);
  const path = url.pathname;
  const extensionMatch = path.match(/\.[^/\.]+$/);

  return extensionMatch?.[0].slice(1) as string;
};

const MediaPreviewModal = forwardRef<MediaPreviewModalRef>(
  function MediaPreviewModal({}, ref) {
    const [mediaSrc, setMediaSrc] = useState<string | null>(null);
    const [mediaType, setMediaType] = useState<"video" | "image" | null>(null);
    const modalRef = useRef<HTMLDivElement>(null);

    const showMedia = (newSrc: string, type: "video" | "image") => {
      setMediaSrc(newSrc);
      setMediaType(type);
    };

    useImperativeHandle(ref, () => ({
      showMedia,
    }));

    const handleClose = () => {
      setMediaSrc(null);
      setMediaType(null);
    };

    return (
      <Modal
        show={!!mediaSrc}
        onHide={handleClose}
        centered
        className="media-preview-modal"
        contentClassName="media-preview-content"
        fullscreen={true}
        ref={modalRef}
      >
        <Modal.Header className="media-preview-header">
          <div role="button" onClick={handleClose}>
            <CancelIcon />
          </div>
        </Modal.Header>
        <Modal.Body className="media-preview-body">
          {mediaSrc && mediaType === "video" && (
            <video width="100%" height="100%" controls>
              <source
                src={mediaSrc}
                type={`video/${extractMediaExtension(mediaSrc)}`}
              />
              Your browser does not support the video tag.
            </video>
          )}
          {mediaSrc && mediaType === "image" && (
            <img
              src={mediaSrc}
              alt="Preview"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          )}
        </Modal.Body>
      </Modal>
    );
  },
);

export default MediaPreviewModal;
